import { render, staticRenderFns } from "./ClassListTemplate.vue?vue&type=template&id=71b02e9e&scoped=true"
import script from "./ClassListTemplate.vue?vue&type=script&lang=ts"
export * from "./ClassListTemplate.vue?vue&type=script&lang=ts"
import style0 from "./ClassListTemplate.vue?vue&type=style&index=0&id=71b02e9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b02e9e",
  null
  
)

export default component.exports